document.addEventListener('DOMContentLoaded', function() {
  let swiper = null;
  const featuredCollections = document.querySelector('.featured-collections');
  const desktopBreakpoint = featuredCollections.classList.contains('featured-collections--grid-at-1500') ? 1500 : 1280;
  
  function initSwiper() {
    if (window.innerWidth < desktopBreakpoint && !swiper) {
      swiper = new Swiper('.featured-collections__swiper', {
        slidesPerView: 1.4,
        spaceBetween: 28,
        loop: false,
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        a11y: {
          enabled: true,
          prevSlideMessage: 'Previous collection',
          nextSlideMessage: 'Next collection',
          firstSlideMessage: 'This is the first collection',
          lastSlideMessage: 'This is the last collection',
          paginationBulletMessage: 'Go to collection'
        },
        breakpoints: {
          560: {
            slidesPerView: 2.5,
            spaceBetween: 28
          },
          768: {
            slidesPerView: 3.5,
            spaceBetween: 28
          },
          992: {
            slidesPerView: 4.5,
            spaceBetween: 28
          },
          1280: {
            slidesPerView: 5.5,
            spaceBetween: 28
          },
        }
      });
    } else if (window.innerWidth >= desktopBreakpoint && swiper) {
      swiper.destroy(true, true);
      swiper = null;
    }
  }
  
  initSwiper();
  
  // Debounced resize handler for better performance
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initSwiper, 150);
  });
});
